import { render, staticRenderFns } from "./NoteView.vue?vue&type=template&id=82a3e490&scoped=true&"
import script from "./NoteView.vue?vue&type=script&lang=js&"
export * from "./NoteView.vue?vue&type=script&lang=js&"
import style0 from "./NoteView.vue?vue&type=style&index=0&id=82a3e490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a3e490",
  null
  
)

export default component.exports